module.exports = __webpack_public_path__ + "img/logo_black_full.51b2019a.svg";